"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Select = require("../form/Select");

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdSearchSelect = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(AdSearchSelect, _Component);

  function AdSearchSelect() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AdSearchSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AdSearchSelect.__proto__ || (0, _getPrototypeOf2.default)(AdSearchSelect)).call.apply(_ref, [this].concat(args))), _this), _this.addField = function () {
      _this.props.fieldProps.addField();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AdSearchSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.fieldProps.length) {
        this.props.fieldProps.addField();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        null,
        this.renderValueFields()
      );
    }
  }, {
    key: "renderValueFields",
    value: function renderValueFields() {
      var _this2 = this;

      return this.props.fieldProps.map(function (fieldProp, index) {
        return _react2.default.createElement(
          "div",
          { className: "row", key: index },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-10" },
            _react2.default.createElement(_Select2.default, (0, _extends3.default)({}, _this2.props, { fieldProps: fieldProp, disableLabel: true }))
          ),
          _react2.default.createElement(
            "div",
            { className: "col-xs-2" },
            _this2.renderButton(index)
          )
        );
      });
    }
  }, {
    key: "renderButton",
    value: function renderButton(index) {
      var numberOfSelects = this.props.fieldProps.length;

      if (index + 1 < numberOfSelects) {
        return _react2.default.createElement(
          "div",
          { className: "ads-select-button", onClick: this.removeField.bind(this, index) },
          _react2.default.createElement(
            "span",
            { className: "ads-select-button-text" },
            "-"
          )
        );
      }

      return _react2.default.createElement(
        "div",
        { className: "ads-select-button", onClick: this.addField },
        _react2.default.createElement(
          "span",
          { className: "ads-select-button-text" },
          "+"
        )
      );
    }
  }, {
    key: "removeField",
    value: function removeField(index) {
      this.props.fieldProps.removeField(index);
    }
  }]);
  return AdSearchSelect;
}(_react.Component), _class.propTypes = {
  placeholder: _react.PropTypes.string.isRequired,
  fieldProps: _react.PropTypes.array.isRequired,
  options: _react.PropTypes.array.isRequired
}, _temp2);
exports.default = AdSearchSelect;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ads/AdSearchSelect.js
 ** module id = 475
 ** module chunks = 0
 **/